import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/official/home/Home.vue'
import Download from '@/views/official/download/Download.vue'
import MobileDownload from '@/views/official/download/MobileDownload.vue'
import About from '@/views/official/about/About.vue'
import Experience from '@/views/official/experience/Experience.vue'
import Cases from '@/views/official/cases/Cases.vue'
import Apply from '@/views/official/apply/Apply.vue'
import SchoolIntroduction from '@/views/official/intro/SchoolIntroduction'
import AreaIntroduction from '@/views/official/intro/AreaIntroduction'

// 移动端路由
import OfficialMobile from '@/views/official/mobile/OfficialMobile'
import MobileHome from '@/views/official/mobile/home/Home'
import AboutSchool from '@/views/official/mobile/info/AboutSchool'
import AboutArea from '@/views/official/mobile/info/AboutArea'
import MobileApply from '@/views/official/mobile/MobileApply'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: '/official/',
    routes: [
        // 官网路由 start
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                header: 'transparent',
                title: '学科网e课堂官网:好内容+好平台_智慧教学解决方案'
            }
        },
        {
            path: '/eclass/school',
            name: 'SchoolIntroduction',
            component: SchoolIntroduction,
            meta: {
                header: 'transparent',
                title: '学校智慧教学解决方案-e课堂'
            }
        },
        {
            path: '/eclass/area',
            name: 'AreaIntroduction',
            component: AreaIntroduction,
            meta: {
                header: 'transparent',
                title: '区域智慧教育解决方案-e课堂'
            }
        },
        {
            path: '/eclass/download',
            name: 'Download',
            component: Download,
            meta: {
                header: 'transparent',
                title: '学科网e课堂下载中心'
            }
        },
        {
            path: '/apply/submit',
            name: 'Apply',
            component: Apply,
            meta: {
                header: 'primary',
                title: '试用申请'
            }
        },
        {
            path: '/eclass/about',
            name: 'About',
            component: About,
            meta: {
                header: 'transparent',
                title: '关于我们'
            }
        },
        {
            path: '/eclass/experience',
            name: 'Experience',
            component: Experience,
            meta: {
                header: 'transparent',
                title: '体验中心'
            }
        },
        {
            path: '/eclass/cases',
            name: 'Cases',
            component: Cases,
            meta: {
                header: 'transparent',
                title: '示范案例'
            }
        },
        // 官网路由 end
        // 移动端下载页面
        {
            path: '/eclass/mobile/download/:type',
            name: 'MobileDownload',
            component: MobileDownload,
            meta: {
                header: 'transparent',
                title: 'APP下载'
            }
        },
        {
            path: '/eclass/mobile',
            name: 'OfficialMobile',
            component: OfficialMobile,
            children: [
                {
                    path: 'home',
                    name: 'MobileHome',
                    component: MobileHome,
                    meta: {
                        title: '首页'
                    }
                },
                {
                    path: 'school',
                    name: 'AboutSchool',
                    component: AboutSchool,
                    meta: {
                        title: '学校教学方案'
                    }
                },
                {
                    path: 'area',
                    name: 'AboutArea',
                    component: AboutArea,
                    meta: {
                        title: '区域教育方案'
                    }
                },
                {
                    path: 'apply',
                    name: 'MobileApply',
                    component: MobileApply,
                    meta: {
                        title: '试用申请',
                        hiddenFooter: true
                    }
                }
            ],
            meta: {
                header: 'transparent',
                title: 'M站'
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        if (to.name === 'Home') {
            document.title = to.meta.title
        } else {
            document.title = to.meta.title + '_学科网e课堂'
        }
    }
    next()
})

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

export default router


